import { render, staticRenderFns } from "./micoapp_menu.vue?vue&type=template&id=45cff7ea&scoped=true"
import script from "./micoapp_menu.vue?vue&type=script&lang=js"
export * from "./micoapp_menu.vue?vue&type=script&lang=js"
import style0 from "./micoapp_menu.vue?vue&type=style&index=0&id=45cff7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cff7ea",
  null
  
)

export default component.exports